import {useState} from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Button from 'react-bootstrap/Button'
import AppCustomization from './AppCustomization/AppCustomization'
import EmailCustomization from './EmailCustomization/EmailCustomization'
import ClientAppCustomization from './ClientAppCustomization/ClientAppCustomization'
import useCurrentUser from '../../hooks/useCurrentUser'

const CustomizationDashboard = ()=>{

	const params = new URLSearchParams(window.location.search)
	const defaultTabKey = params.get('tab') || 'app_customization'
	const [activeTabKey,setActiveTabKey] = useState(defaultTabKey)
	const handleTabClick = (key)=>{
		setActiveTabKey(key)
	}

	const user = useCurrentUser()
	const pageTypeText = (
		user.account_type === 'gym'
		? 'Gym'
		: 'Trainer'
	)

	const tabs = [
		{
			title:`${pageTypeText} Page & Custom App`,
			key:'app_customization',
			tooltip:`Customize the look of your app and ${pageTypeText} Page.`
		},{
			title:'Email Customization',
			key:'email_customization',
			tooltip:'Customize the email that new clients recieve when they sign up.'
		},{
			title:'Client App Customization',
			key:'client_app_customization',
			tooltip:'Customize what features are available to clients.'
		}
	]

	const tabKeyComponentMap = {
		app_customization:<AppCustomization/>,
		email_customization:<EmailCustomization/>,
		client_app_customization:<ClientAppCustomization/>
	}

	return (
		<div className="pt-3 px-2 px-md-3">
			<div className="mb-2">
				{tabs.map(tab=>(
					<OverlayTrigger placement="bottom" overlay={
						<Tooltip>{tab.tooltip}</Tooltip>
					}>
						<Button 
							onClick={handleTabClick.bind(null,tab.key)}
							variant={
								activeTabKey === tab.key
								? "primary"
								: "outline-primary"
							}
							className="mr-1 mb-1"
							key={tab.key}
							size="sm"
						>
							{tab.title}
						</Button>
					</OverlayTrigger>
				))}
			</div>
			<div>{tabKeyComponentMap[activeTabKey]}</div>
		</div>
	)
}



export default CustomizationDashboard